import type { SVGProps } from 'react';

const SvgUserUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16.2 12.04c.81-.96 1.3-2.19 1.3-3.54C17.5 5.47 15.03 3 12 3a5.51 5.51 0 0 0-5.5 5.5c0 1.35.49 2.58 1.3 3.54A8.96 8.96 0 0 0 3 20c0 .55.45 1 1 1s1-.45 1-1c0-2.97 1.84-5.55 4.6-6.56.73.35 1.54.56 2.4.56s1.67-.2 2.4-.56C17.16 14.45 19 17.02 19 20c0 .55.45 1 1 1s1-.45 1-1c0-3.41-1.87-6.43-4.8-7.96M8.5 8.5C8.5 6.57 10.07 5 12 5s3.5 1.57 3.5 3.5S13.93 12 12 12s-3.5-1.57-3.5-3.5"
    />
  </svg>
);
export default SvgUserUser;
